export class UserManagementReducerError extends Error {
  constructor(
    message: string,
    public details: Array<string> = [],
  ) {
    super(message)
    this.name = UserManagementReducerError.name
  }
}
